export default __webpack_public_path__ + "static/kristel_snepvangers-d438098a3cfbc5bf0cfff3f14a07aa93.jpg";